//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.FeatureBuilder.js";
let d=[[[0,"AssemblyOptions",1,0],[0,"FileBrowser",1,0],[0,"ShipLibType",1,0]],[],[]];
SPLM.Features.ShipDesign.UpdateShipLibraryBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.UpdateShipLibraryBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.UpdateShipLibraryBuilder.ShipLibOptionType = Object.freeze({
    "Profile" : "Profile", "Belt" : "Belt", "Cutout" : "Cutout", "Endcut" : "Endcut", "Support" : "Support", "SupportCap" : "SupportCap", "WeldOnEdge" : "WeldOnEdge", "Bracket" : "Bracket", "WeldAlongEdge" : "WeldAlongEdge"});

SPLM.Features.ShipDesign.UpdateShipLibraryBuilder.ShipLibAssemblyOption = Object.freeze({
    "WorkPart" : "WorkPart", "WorkPartandComponents" : "WorkPartandComponents", "WorkPartandComponentswithLibraries" : "WorkPartandComponentswithLibraries"});

export default SPLM;